// extracted by mini-css-extract-plugin
module.exports = {"spinnerLoadMore":"spinner_spinnerLoadMore__G42SA","video-spin":"spinner_video-spin__4OUl1"};